import { ErrorType, EveError } from '@ver-uds/e-verify';
import React, { Component, ErrorInfo, ReactNode } from 'react';
import { Employers } from '../../constants/ContactInfo';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      hasError: false,
    };
  }

  public static getDerivedStateFromError(): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error('Uncaught error:', error, errorInfo);
  }

  public render(): ReactNode {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return <EveError errorType={ErrorType.GENERAL} product="E-Verify" contact={Employers.emailAddress.href} />;
    }

    return children;
  }
}

export default ErrorBoundary;
